<section class="offset-width well-white">
  <div *ngIf="loader" class="loader-spin"></div>
  <app-header [pageName]="'Delivery Management'"></app-header>

  <div class="container-fluid delivery-management-container">
    <!-- Top Delivery Management Header -->
    <div class="delivery-header-card d-flex align-items-center mb-4">
      <div class="delivery-header-icon-box">
        <i class="fa fa-truck delivery-header-icon"></i>
      </div>
      <div class="delivery-header-text">
        <h2 class="delivery-page-title">Delivery Management</h2>
        <p class="delivery-page-subtitle">Configure delivery settings for local and Pan India orders.</p>
      </div>
    </div>

    <!-- Tabs Navigation -->
    <div class="delivery-tabs-container mb-4">
      <div class="delivery-tab-nav">
        <button type="button" class="delivery-tab-btn" [ngClass]="{ active: activeTab === 'local' }"
          (click)="setTab('local')">
          <i class="fa fa-map-marker tab-icon"></i>
          <span>Local Delivery</span>
        </button>

        <button type="button" class="delivery-tab-btn" [ngClass]="{ active: activeTab === 'panIndia' }"
          (click)="setTab('panIndia')">
          <i class="fa fa-truck tab-icon"></i>
          <span>Pan India Delivery</span>
        </button>
      </div>
    </div>

    <!-- Local Delivery Tab Content -->
    <div *ngIf="activeTab === 'local'">
      <div class="main-delivery-card" *ngIf="permission.hasPermission(['delivery'], ['delivery_view'])">
        <div class="card-inner-padding">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <div class="d-flex align-items-center">
              <div class="section-icon-badge">
                <i class="fa fa-map-marker"></i>
              </div>
              <div>
                <h4 class="section-title">Local Delivery Settings</h4>
                <p class="section-subtitle">Manage delivery areas, pincodes, and charges for local delivery.</p>
              </div>
            </div>

            <button type="button" *ngIf="permission.hasPermission(['delivery'], ['delivery_create'])" (click)="create()"
              class="button-1 btn-pink">
              <i class="fa fa-plus mr-1"></i> Create
            </button>
          </div>

          <div class="table-responsive">
            <table class="table modern-table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">PINCODE</th>
                  <th scope="col">CITY</th>
                  <!-- <th scope="col">MINIMUM AMOUNT</th> -->
                  <th style="text-align: right;" scope="col">DELIVERY CHARGE</th>
                  <th scope="col">NIGHT DELIVERY AVAILABILITY</th>
                  <th style="text-align: right;" scope="col">NIGHT DELIVERY CHARGE</th>
                  <th *ngIf="
                      permission.hasPermission(
                        ['delivery'],
                        ['delivery_view', 'delivery_delete', 'delivery_update']
                      )
                    " scope="col">
                    ACTION
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of getdata; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td class="font-weight-600">{{ item.pincode }}</td>
                  <td>{{ item.city }}</td>
                  <!-- <td>{{item.minimumAmount}}</td> -->
                  <td style="text-align: right;">₹ {{ item.deliveryCharge ? (item.deliveryCharge.toFixed(2)) : '-' }}
                  </td>
                  <td>
                    <span class="status-badge" [ngClass]="item.enablemidDelivery ? 'badge-yes' : 'badge-no'">
                      {{ item.enablemidDelivery ? 'YES' : 'NO' }}
                    </span>
                  </td>
                  <td style="text-align: right;">{{ item.middeliveryCharge != null ? '₹ ' +
                    (item.middeliveryCharge?.toFixed(2)) : '-' }}</td>
                  <td *ngIf="adminAccess?.privileges?.deliveryWrite">
                    <img class="pointer mr-2" src="/assets/images/icon/pencil-2.svg" *ngIf="
                        permission.hasPermission(['delivery'], ['delivery_update'])
                      " (click)="onClickEdit(item)" />
                    <i class="fa fa-trash del-icon" *ngIf="
                        permission.hasPermission(['delivery'], ['delivery_delete'])
                      " (click)="deleteData(item.deliveryId)"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Pan India Delivery Tab Content -->
    <div *ngIf="activeTab === 'panIndia'">
      <div class="main-delivery-card" *ngIf="permission.hasPermission(['delivery'], ['delivery_view'])">
        <div class="card-inner-padding">
          <!-- Section Header -->
          <div class="d-flex align-items-center mb-3">
            <div class="section-icon-badge">
              <i class="fa fa-cog"></i>
            </div>
            <div>
              <h4 class="section-title">Pan India Delivery Settings</h4>
              <p class="section-subtitle">Configure the estimated delivery time for orders shipped across India.</p>
            </div>
          </div>

          <!-- Settings Form Card (Subtle Pink Box) -->
          <div class="settings-form-box">
            <form [formGroup]="panIndiaForm" (ngSubmit)="updatePanIndiaDeliveryDays()">
              <div class="form-group mb-2">
                <label class="field-label">
                  Expected Delivery Days <span class="required-star">*</span>
                </label>
                <div class="input-group days-input-group">
                  <input type="number" class="form-control days-input" formControlName="panIndiaDeliveryDays"
                    placeholder="Enter Delivery Days" min="1" />
                  <div class="input-group-append">
                    <span class="input-group-text days-addon">Days</span>
                  </div>
                </div>
                <p class="field-help-text">Enter the number of days for Pan India delivery.</p>
                <div *ngIf="panIndiaSubmitted && pif.panIndiaDeliveryDays.errors" class="invalid-text mt-1">
                  <div *ngIf="pif.panIndiaDeliveryDays.errors.required">
                    Delivery Days is required
                  </div>
                  <div *ngIf="pif.panIndiaDeliveryDays.errors.min || pif.panIndiaDeliveryDays.errors.pattern">
                    Please enter a valid positive number of days (minimum 1)
                  </div>
                </div>
              </div>

              <div class="mt-4">
                <button type="submit" class="save-changes-btn"
                  *ngIf="permission.hasPermission(['delivery'], ['delivery_update'])">
                  <i class="fa fa-save mr-2"></i>
                  <span>Update</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal for Create/Update Local Delivery -->
    <div class="modal fade bd-example-modal-lg" id="createModal" tabindex="-1" role="dialog"
      aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <form [formGroup]="form">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel"> <span> {{isEdited==true ? "Update" : "Create"}}</span>
                Delivery</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <label>Delivery Pincode <span style="color: red;">*</span></label><br />
              <input type="number" class="form-control" placeholder="Enter Delivery Pincode"
                formControlName="pincode" />
              <div *ngIf="submitted && f.pincode.errors" class="invalid-text">
                <div *ngIf="f.pincode.errors.required">Pincode is required</div>
                <div *ngIf="f.pincode.errors.pattern">
                  Enter Valid 6 digit pincode
                </div>
              </div>
              <br />

              <label>Delivery Area <span style="color: red;">*</span></label><br />
              <input type="text" class="form-control" placeholder="Enter Delivery area" formControlName="city" />
              <div *ngIf="submitted && f.city.errors" class="invalid-text">
                <div *ngIf="f.city.errors.required">City is required</div>
              </div>
              <br />

              <label>Delivery Charge (In Rupees) <span style="color: red;">*</span></label><br />
              <input type="number" class="form-control" placeholder="Enter Delivery Charge"
                formControlName="deliveryCharge" />
              <div *ngIf="submitted && f.deliveryCharge.errors" class="invalid-text">
                <div *ngIf="f.deliveryCharge.errors.required">
                  This field is required
                </div>
                <div *ngIf="f.deliveryCharge.errors.min">
                  Delivery charge cannot be negative
                </div>
              </div>
              <br />

              <label>Mid Night Delivery <span style="color: red;">*</span></label><br />
              <select class="form-control" formControlName="enablemidDelivery"
                (change)="midDelivery($event.target.value)">
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
              <div *ngIf="submitted && f.enablemidDelivery.errors" class="invalid-text">
                <div *ngIf="f.enablemidDelivery.errors.required">
                  This field is required
                </div>
              </div>
              <br />
              <div *ngIf="f.enablemidDelivery.value =='true'">
                <label> Mid-Night Delivery charge (In Rupees) <span style="color: red;">*</span></label><br />
                <input type="number" class="form-control" placeholder="Enter Mid-Night Delivery charge"
                  formControlName="middeliveryCharge" />
                <div *ngIf="submitted && f.middeliveryCharge.errors" class="invalid-text">
                  <div *ngIf="f.middeliveryCharge.errors.required">
                    This field is required
                  </div>
                </div>
                <br />
              </div>
            </div>
            <!--End Modal Body-->
            <div class="modal-footer">
              <button type="button" class="button-1 btn-white" data-dismiss="modal" (click)="close()">
                Close
              </button>
              <button type="button" class="button-1 btn-pink" (click)="onSubmit()">
                Submit
                <i style="margin-left: 4px" class="fa fa-long-arrow-right"></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</section>